<template>
  <i
    class="tm-audio-resize"
    :class="{
      l: $props.fromLeft,
      r: $props.fromRight,
      n: isNarrow,
      v: $props.visible,
      a: isActive,
    }"
    :style="styleObj"
    @mouseenter="$_toggleHover"
    @mouseleave="$_toggleHover"
    v-tm-move="moveObj"
  >
    <i class="-mark" />
    <i class="-mark" />
  </i>
</template>

<script>
import resizeAudioMixin from 'v/Story/Timeline/view/resizable/resizeAudio';
import tmMove from 'v/Story/Timeline/view/movable/tmMove';
import _ from 'lodash-extended';
import { getAudioResizeWindow } from 'v/Story/Timeline/api/asset';
import {
  getResizeAvailability,
  mapAvailability2Cursor,
} from 'v/Story/Timeline/api/tapi';
import { mapState } from 'vuex';

export default {
  name: 'tm-audio-resize',
  mixins: [resizeAudioMixin],
  directives: { tmMove },

  props: {
    fromLeft: { type: Boolean, required: false, default: false },
    fromRight: { type: Boolean, required: false, default: false },
    track: { type: Object, required: true },
    visible: { type: Boolean, required: true },
  },

  data() {
    return {
      hovered: false,
    };
  },

  computed: {
    ...mapState('timemachine', {
      pxResizeW: (state) => state.cssVariables.pxResizeW,
    }),

    isActive() {
      return this.$data.hovered;
    },

    rectangle() {
      return this.$props.fromLeft
        ? _.first(this.track.rectangles)
        : _.last(this.track.rectangles);
    },

    isNarrow() {
      return this.rectangle
        ? this.rectangle.width <= 2 * this.pxResizeW
        : false;
    },

    styleObj() {
      let cursor = null;
      if (this.isActive) {
        // checking for cursor only if isActive to minimize load while rendering bunch of assets
        const resizeWindow = getAudioResizeWindow(this.$props.track);
        const availability = getResizeAvailability(
          resizeWindow,
          this.$props.track.data
        );
        const cursorMap = mapAvailability2Cursor(availability);
        cursor = this.$props.fromLeft ? cursorMap.left : cursorMap.right;
      }

      return !this.rectangle
        ? null
        : {
            transform: `translate3d(${
              this.$props.fromLeft ? this.rectangle.p1.x : this.rectangle.p2.x
            }px, ${this.rectangle.p1.y}px, 0)`,
            ...(cursor ? { cursor } : null),
          };
    },
  },

  methods: {
    $_toggleHover(e) {
      this.$data.hovered = e.type === 'mouseenter';
      this.$emit('hovered', this.$data.hovered, this.rectangle);
    },
  },
};
</script>

<style lang="scss">
.tm-audio > .tm-audio-resize {
  --mark-colour: #fff;

  position: absolute;
  top: var(--tm-pxAudioTopOffset);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--tm-zVisualResize);
  width: var(--tm-pxResizeW);
  height: var(--tm-pxAudioTrackH);
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s linear;

  > .-mark {
    margin-left: 1px;
    width: 2px;
    height: 20px;
    background-color: var(--mark-colour);
    box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);
  }

  &.v {
    visibility: visible;
    opacity: 1;
  }

  &.a {
    --mark-colour: var(--tm-audioBorder2);
  }

  &.l {
    left: 0;

    &.n {
      left: -8px;
      width: 8px;

      > .-mark:first-child {
        width: 8px;
        height: 8px;
        background-color: var(--mark-colour);
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
        margin: 0;
      }
      > .-mark:last-child {
        display: none;
      }
    }
  }

  &.r {
    right: 0;

    &.n {
      right: -8px;
      width: 8px;

      > .-mark:first-child {
        width: 8px;
        height: 8px;
        background-color: var(--mark-colour);
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
        margin: 0;
      }
      > .-mark:last-child {
        display: none;
      }
    }
  }
}
</style>
